import React from 'react';
import MediaSourceField from './MediaSourceField';
import { useSelectedItemProps } from './useSelectedItemProps';

function BlockMediaField({ value, onChange, label, allowVideo }) {
  const { itemProps } = useSelectedItemProps();
  return (
    <MediaSourceField
      value={value}
      onChange={onChange}
      fieldLabel={label}
      allowVideo={allowVideo}
      mediaFit={itemProps.mediaFit}
    />
  );
}

/** Champ Puck : image, vidéo fichier ou embed (YouTube / Vimeo). */
export function puckMediaField(label, options = {}) {
  return {
    type: 'custom',
    label,
    render: ({ onChange, value }) => (
      <BlockMediaField
        value={value}
        onChange={onChange}
        label={label}
        allowVideo={options.allowVideo !== false}
      />
    ),
  };
}
